import React from 'react';
import { Content } from 'antd/es/layout/layout';
import { Col, Form, Input, Radio, Row, Space, Table } from 'antd';
import { HocChangePagination } from 'utils/HocChangePagination';
import Button from 'components/Button';
import { Icabinet } from 'interface/cabinet.interface';
import useQueryParam from 'hooks/useQueryPrams';

export default function UploadFileCabinet() {
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 4;
  const functionParams = {
    page: page,
    page_size: page_size,
  };
  const columns = [
    {
      title: 'Mã tủ',
      dataIndex: 'id',
      width: 80,
    },
    {
      title: 'Mô hình',
      dataIndex: 'model',
      width: 120,
    },
    {
      title: 'Loại tủ',
      dataIndex: 'description',
      width: 200,
    },
    {
      title: 'Hình ảnh',
      width: 150,
      render: (_: any, record: Icabinet) => {
        return (
          <img style={{ width: 80, height: 80 }} src={record?.image} alt="" />
        );
      },
    },
    {
      title: 'Ngang',
      dataIndex: 'horizontal',
      width: 100,
    },
    {
      title: 'dọc',
      width: 100,
      dataIndex: 'vertical',
    },
    {
      title: 'tên tủ',
      width: 120,
      dataIndex: 'vertical',
    },
    {
      title: (
        <div>
          Số lượng món tối thiểu <br /> <span>(khuyến nghị)</span>
        </div>
      ),
      dataIndex: 'min_product',
      width: 220,
    },
    {
      title: 'SL',
      width: 100,
      render: () => {
        return <p>-</p>;
      },
    },
  ];
  return (
    <div>
      <Form layout="vertical">
        <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="" span={21}>
            <Form.Item label="Cập nhật tủ, dòng hàng*">
              <Input disabled={true} placeholder="nhập file" className="" />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Button
              bgColor={'bg-white'}
              color={'text-primary-50'}
              border="border-primary-50"
            >
              Browser
            </Button>
          </Col>
        </Row>
      </Form>

      <div className="mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          scroll={{ x: 858 }}
          className="customTable"
          // dataSource={cabinetResult?.data}
          // loading={''}
          pagination={{
            current: page,
            pageSize: page_size,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '15', '20'],
            onChange: HocChangePagination(history),
          }}
        />
      </div>

      <div className="mt-20 pt-4 border-t-2 border-neutral-90">
        <Form>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mb-1"
          >
            <Col span={12} className="flex justify-end">
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border="border-primary-50"
                >
                  Trở lại
                </Button>
                <Button>Cập nhật</Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}
